import React from "react";

import TabData from "./TabData";
import {
  DetailedUploadCard,
  DetailedUploadCardWithoutPanelsWithoutSlots,
  // DetailedViewCard,
} from "./DetailedViewCards";
import {
  DefaultEmptyCard,
  DefaultViewCard,
  // DefaultViewCard2,
} from "./defaultViewCard";
import {
  UpdatedUploadCard,
  UpdatedUploadCardWithoutPanelsWithoutSlots,
  // UpdatedViewCard,
} from "./UpdatedViewCards";

const DocsTable = ({
  data,

  handleDocPreview,
  handleDrop,
  handleUploadPopup,
  isSlotUploading,
  isDragging,
  refetchLoading,
  handleDropwithOutpanlesWithoutslots,
  handleUploadPopupwithoutSlots,
  isDragginguploadingbutton,
  uploadbuttonLoadingid,
  // unAttachedDocuments,
  loading,
  refetchData,
  pageView,
}) => {
  return (
    <>
      {data?.data?.map((page, index) => {
        if (page?.page?.show_on_sidebar === true) {
          if (page?.page?.name === "Treatment") {
            return (
              <React.Fragment key={index}>
                <div className="m-b-5 flex-nowrap align-items-center">
                  <div className="panel-icon" style={{ marginRight: "5px", left: "0px" }}>
                    <img
                      src={page?.page?.page_icon}
                      className="ic ic-25 d-flex align-items-center justify-content-center"
                    />
                  </div>
                  <div
                    className="panel-color"
                    style={{
                      background: "var(--primary)",
                      left: "33px",
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "600",
                      fontSize: "16px",
                      fontFamily: "Inter",
                      textTransform: "uppercase",
                    }}
                  >
                    {/* <div style={{ height: 0, width: "10px" }} /> */}
                    <h4
                      className="d-flex align-items-center"
                      style={{ color: "white", height: "max-content", paddingLeft: "9px" }}
                    >
                      <small
                        className="font-weight-600 anti-skew"
                        style={{ textDecoration: "none" }}
                      >
                        {page?.page?.name}
                      </small>
                    </h4>
                  </div>
                </div>
                {/* height 80vh */}
                <div key={index}>
                  {page?.panels?.map((item) => (
                    <div key={item.id} className="document-panel-wrapper m-b-0 m-t-5">
                      <div
                        className="d-flex align-items-center"
                        style={{
                          cursor: "default",
                          background: item?.specialty?.secondary_color,
                          width: "100%",
                          height: "25px",
                          fontWeight: 600,
                        }}
                      >
                        <div
                          style={{
                            width: "25px",
                            minWidth: "25px",
                            height: "25px",
                            backgroundColor: item?.specialty?.color,
                            color: "white",
                            fontSize: "16px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <p
                            style={{
                              textTransform: "uppercase",
                              textAlign: "center",
                              margin: "0 auto",
                              fontWeight: "bold",
                            }}
                          >
                            {item?.specialty?.name[0]}
                          </p>
                        </div>
                        <p
                          style={{
                            color: "black !important",
                            fontSize: "14px",
                            margin: "0",
                            padding: "0 5px",
                            textTransform: "sentencecase",
                          }}
                        >
                          {item?.panel_name || item?.specialty?.name}
                        </p>
                      </div>
                      <div
                        className="tbdocument redtd2 flex-row m-0"
                        style={{
                          gap: "5px",
                        }}
                      >
                        <div className="col p-0 p-r-5">
                          {/* <div className="height-25 m-b-5">
                            <h4
                              // style={{ backgroundColor: "var(--primary-15)" }}
                              className="bg-primary-5 text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case font-weight-semibold text-center client-contact-title"
                            >
                              {item?.panel_name || ""} Document Row
                            </h4>
                          </div> */}
                          <div
                            className="icon-text-boxes d-flex flex-wrap w-100 e-template-row  m-t-5"
                            style={{
                              marginRight: pageView === "default" ? "5px" : 0,
                              height:
                                pageView === "detailed"
                                  ? "322px"
                                  : pageView === "updated"
                                    ? "152px"
                                    : "auto",
                            }}
                          >
                            {page?.slots?.map((slot) => {
                              // const attachedDocs = item?.documents?.filter(
                              //   (doc) =>
                              //     doc?.document_slot?.id === slot?.id &&
                              //     doc?.document_slot?.slot_number !== 0
                              // );
                              // const attachedDocs = slot?.docs?.filter(
                              //   (doc) =>
                              //     doc?.document_slot?.id === slot?.id &&
                              //     doc?.document_slot?.slot_number !== 0
                              // );
                              const attachedDocs = item?.docs?.filter(
                                (doc) => doc?.document_slot?.id === slot?.id
                              );

                              return (
                                <React.Fragment key={slot.id}>
                                  {attachedDocs?.length > 0
                                    ? attachedDocs.map((doc) => (
                                        <DefaultViewCard
                                          key={doc.id}
                                          doc={doc}
                                          slot={slot}
                                          handleDocPreview={handleDocPreview}
                                        />
                                      ))
                                    : slot.slot_number !== 0 && (
                                        <DefaultEmptyCard
                                          slot={slot}
                                          page={page}
                                          item={item}
                                          isDragging={isDragging}
                                          refetchLoading={refetchLoading}
                                          handleDrop={handleDrop}
                                          handleUploadPopup={handleUploadPopup}
                                          isSlotUploading={isSlotUploading}
                                        />
                                      )}
                                </React.Fragment>
                              );
                            })}
                          </div>
                        </div>
                        {pageView === "default" ? (
                          <>
                            {/* <DefaultUploadCard
                            page={page}
                            item={item}
                            isDragginguploadingbutton={isDragginguploadingbutton}
                            uploadbuttonLoadingid={uploadbuttonLoadingid}
                            handleDropwithOutpanlesWithoutslots={
                              handleDropwithOutpanlesWithoutslots
                            }
                            handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                          /> */}
                          </>
                        ) : pageView === "detailed" ? (
                          <DetailedUploadCard
                            page={page}
                            item={item}
                            isDragginguploadingbutton={isDragginguploadingbutton}
                            uploadbuttonLoadingid={uploadbuttonLoadingid}
                            handleDropwithOutpanlesWithoutslots={
                              handleDropwithOutpanlesWithoutslots
                            }
                            handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                          />
                        ) : (
                          <UpdatedUploadCard
                            page={page}
                            item={item}
                            isDragginguploadingbutton={isDragginguploadingbutton}
                            uploadbuttonLoadingid={uploadbuttonLoadingid}
                            handleDropwithOutpanlesWithoutslots={
                              handleDropwithOutpanlesWithoutslots
                            }
                            handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                  {(page?.panels === null || page?.panels?.length === 0) && (
                    <div
                      className="tbdocument redtd2 flex-row m-0"
                      style={{
                        gap: "5px",
                      }}
                    >
                      {/* <div className="col p-0">
                        <div className="height-25 m-b-5">
                          <h4
                            // style={{ backgroundColor: "var(--primary-15)" }}
                            className="bg-primary-5 text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case font-weight-semibold text-center client-contact-title"
                          >
                            Document Row
                          </h4>
                        </div>
                      </div> */}
                      {(page?.panels === null || page?.panels?.length === 0) &&
                      page?.slots?.length > 0 ? (
                        pageView === "default" ? (
                          <>
                            {/* <DefaultUploadCardWithoutPanelsWithoutSlots
                            page={page}
                            isDragginguploadingbutton={isDragginguploadingbutton}
                            handleDropwithOutpanlesWithoutslots={
                              handleDropwithOutpanlesWithoutslots
                            }
                            handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                          /> */}
                          </>
                        ) : pageView === "detailed" ? (
                          <DetailedUploadCardWithoutPanelsWithoutSlots
                            page={page}
                            item={null}
                            isDragginguploadingbutton={isDragginguploadingbutton}
                            uploadbuttonLoadingid={uploadbuttonLoadingid}
                            handleDropwithOutpanlesWithoutslots={
                              handleDropwithOutpanlesWithoutslots
                            }
                            handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                          />
                        ) : (
                          <UpdatedUploadCardWithoutPanelsWithoutSlots
                            page={page}
                            item={null}
                            isDragginguploadingbutton={isDragginguploadingbutton}
                            uploadbuttonLoadingid={uploadbuttonLoadingid}
                            handleDropwithOutpanlesWithoutslots={
                              handleDropwithOutpanlesWithoutslots
                            }
                            handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                          />
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  )}

                  {/* {unAttachedDocuments().length > 0 && (
                    <>
                      <div className="m-l-7 m-b-5 flex-nowrap align-items-center">
                        <div
                          className="panel-color"
                          style={{
                            background: "var(--primary)",
                            left: "25px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              height: 0,
                              width: "10px",
                              maxHeight: "max-content",
                              minHeight: "max-content",
                            }}
                          />
                          <h4
                            className="d-flex align-items-center  m-l-5"
                            style={{ color: "white" }}
                          >
                            <small className="font-weight-600 anti-skew">
                              Unattached Documents
                            </small>
                          </h4>
                        </div>
                      </div>
                      <div
                        // className="icon-text-boxes d-flex flex-wrap w-100 e-template-row m-t-5"
                        className="w-100 m-t-5 unattached-documents-container"
                        style={{
                          marginRight: "5px",
                          justifyContent: "end",
                          height: "auto",
                          ...(pageView !== "default" && {
                            display: "flex",
                            justifyContent: "flex-start",
                            flexWrap: "wrap",
                          }),
                        }}
                      >
                        {unAttachedDocuments().map((document) =>
                          pageView === "default" ? (
                            <DefaultViewCard2
                              key={document.id}
                              doc={document}
                              slot={undefined}
                              handleDocPreview={handleDocPreview}
                            />
                          ) : pageView === "detailed" ? (
                            <DetailedViewCard
                              key={document.id}
                              doc={document}
                              slot={undefined}
                              handleDocPreview={handleDocPreview}
                              modifiedView={true}
                            />
                          ) : (
                            <UpdatedViewCard
                              key={document.id}
                              doc={document}
                              slot={undefined}
                              handleDocPreview={handleDocPreview}
                              modifiedView={true}
                            />
                          )
                        )}
                      </div>
                    </>
                  )} */}
                </div>
              </React.Fragment>
            );
          } else if (page?.page?.name !== "Treatment") {
            return (
              <div key={index}>
                <div className="m-l-7 m-b-5 flex-nowrap align-items-center">
                  <div className="panel-icon" style={{ marginRight: "5px", left: "0px" }}>
                    <img
                      src={page?.page?.page_icon}
                      height={25}
                      width={25}
                      className="ic ic-25 d-flex align-items-center justify-content-center"
                    />
                  </div>
                  <div
                    className="panel-color"
                    style={{
                      background: "var(--primary)",
                      left: "33px",
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "600",
                      fontSize: "16px",
                      fontFamily: "Inter",
                      textTransform: "uppercase",
                    }}
                  >
                    {/* <div style={{ height: 0, width: "10px" }} /> */}
                    <h4
                      className="d-flex align-items-center"
                      style={{ color: "white", height: "max-content", paddingLeft: "9px" }}
                    >
                      <small className="font-weight-600 anti-skew">{page?.page?.name}</small>
                    </h4>
                  </div>
                </div>
                <TabData
                  data={page || []}
                  loading={loading}
                  all={true}
                  refetchData={refetchData}
                  pageView={pageView}
                />
              </div>
            );
          }
          return null;
        }
      })}
    </>
  );
};

export default DocsTable;
